import { ChipContent as UIChipContent } from "@webmotors/eleanor-ui";

export interface ChipContentProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
  label: string;
  labelAs?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "span";
  onClick?: (event?: React.MouseEvent<HTMLElement>) => void;
  size?: "small" | "medium";
  state?: "disabled" | "active" | "default";
  quantityText?: string;
  leftIcon?: React.ReactNode;
}

export function ChipContent({
  className,
  label,
  labelAs,
  onClick,
  size = "medium",
  state = "default",
  quantityText,
  leftIcon,
  ...props
}: Readonly<ChipContentProps>) {
  return (
    <UIChipContent
      className={className}
      label={label}
      labelAs={labelAs}
      onClick={onClick}
      size={size}
      state={state}
      quantityText={quantityText}
      leftIcon={leftIcon}
      data-testid="chip-content"
      {...props}
    />
  );
}